module.exports = __webpack_public_path__ + "img/border-none.6930938e.svg";